// DEPENDENCIES ---------------------------------------------------------------- //

import { Box, Tooltip, Typography } from '@mui/material';

import { allTokens, MONO_FONT } from '../../../lib/tokens';
import InvoiceStatusChip from '@features/invoices/components/InvoiceStatusChip';

// TYPES ---------------------------------------------------------------- //

type InvoiceDetailsHeadingProps = {
  invoiceId?: number | string | null;
  customerName?: string | null;
  status?: string | null;
};

// COMPONENT ---------------------------------------------------------------- //

/**
 * The customer name leads, because that is what a dealer with several rooftops came
 * looking for. The id is mono for comparing against an email or a statement
 * character by character.
 *
 * Both invoice engines' detail panes render this, so the header cannot drift between them.
 */
const InvoiceDetailsHeading = ({ invoiceId, customerName, status }: InvoiceDetailsHeadingProps) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap', mb: 2 }}>
    <Typography variant='h5' sx={{ lineHeight: 1.2, fontWeight: 600 }}>
      {customerName}
    </Typography>

    <Tooltip title='HopDrive invoice id' placement='top'>
      <Typography sx={{ fontFamily: MONO_FONT, fontSize: 13, color: allTokens.palette.secondaryAccent[700] }}>
        #{invoiceId}
      </Typography>
    </Tooltip>

    <InvoiceStatusChip status={status} />
  </Box>
);

// EXPORT ---------------------------------------------------------------- //

export default InvoiceDetailsHeading;
